import React, { useState, useEffect, useRef } from 'react';
import { Modal, Box, Typography, LinearProgress } from '@mui/material';

export default function ModalStatusWaitingProcess({ open, totalRegistros, titulo, pendientes, completadas, fallidas, msPorRegistro = 3000, progreso, mensaje }) {
    const [progress, setProgress] = useState(0);
    const timerRef = useRef(null);
    const startTimeRef = useRef(null);
    const totalTimeRef = useRef(1000);
    const tieneProgresoReal = progreso !== undefined && progreso !== null && progreso !== "" && Number.isFinite(Number(progreso));

    useEffect(() => {
        if (open && tieneProgresoReal) {
            setProgress(Math.max(0, Math.min(Number(progreso), 100)));
        } else if (open) {
            setProgress(0);
            startTimeRef.current = Date.now();
            totalTimeRef.current = Math.max(Number(totalRegistros || 0) * Number(msPorRegistro || 0), 1000);

            const updateProgress = () => {
                const elapsed = Date.now() - startTimeRef.current;
                const pct = Math.min((elapsed / totalTimeRef.current) * 100, 99);
                setProgress(pct);
                timerRef.current = requestAnimationFrame(updateProgress);
            };
            timerRef.current = requestAnimationFrame(updateProgress);
        } else {
            setProgress(0);
            if (timerRef.current) {
                cancelAnimationFrame(timerRef.current);
                timerRef.current = null;
            }
        }
        return () => {
            if (timerRef.current) {
                cancelAnimationFrame(timerRef.current);
                timerRef.current = null;
            }
        };
    }, [open, totalRegistros, msPorRegistro, progreso, tieneProgresoReal]);

    const mostrarStats = pendientes !== undefined && completadas !== undefined && fallidas !== undefined;

    return (
        <Modal
            open={open}
            disableEnforceFocus
            disableAutoFocus
            closeAfterTransition
        >
            <Box sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: 400,
                bgcolor: 'background.paper',
                borderRadius: 2,
                boxShadow: 24,
                p: 4,
                textAlign: 'center',
            }}>
                <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
                    {titulo || "Procesando..."}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                    {mensaje || `Procesando ${totalRegistros} registro(s)...`}
                </Typography>
                {mostrarStats && (
                    <Typography variant="body2" sx={{ mb: 2 }}>
                        Completadas: {completadas} | Fallidas: {fallidas} | Pendientes: {pendientes}
                    </Typography>
                )}
                <LinearProgress
                    variant="determinate"
                    value={progress}
                    sx={{ height: 10, borderRadius: 5, mb: 1 }}
                />
                <Typography variant="caption" color="text.secondary">
                    {Math.round(progress)}%
                </Typography>
                {!tieneProgresoReal && (
                    <Typography variant="caption" display="block" color="text.secondary" sx={{ mt: 2 }}>
                        Tiempo estimado: {Math.max(Math.ceil(Number(totalRegistros || 0) * Number(msPorRegistro || 0) / 1000), 1)} segundos
                    </Typography>
                )}
            </Box>
        </Modal>
    );
}
